// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-group-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.input-group-container input {
  width: 100%;
  flex: 2 1;
}

.input-group-container select {
  width: 100%;
  flex: 1 1;
}`, "",{"version":3,"sources":["webpack://./src/App/components/Loan/admin/LoanProducts/CreateLoanProductModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,SAAO;AACT;;AAEA;EACE,WAAW;EACX,SAAO;AACT","sourcesContent":[".input-group-container {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.input-group-container input {\n  width: 100%;\n  flex: 2;\n}\n\n.input-group-container select {\n  width: 100%;\n  flex: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
